__turbopack_context__.v({
  "captcha": "F5r8Za_captcha",
  "color_divider1": "F5r8Za_color_divider1",
  "comment_section": "F5r8Za_comment_section",
  "comment_user": "F5r8Za_comment_user",
  "container2": "F5r8Za_container2",
  "desktop_view": "F5r8Za_desktop_view",
  "detail_banner": "F5r8Za_detail_banner",
  "faq_right": "F5r8Za_faq_right",
  "featuredImage": "F5r8Za_featuredImage",
  "grey-divider1": "F5r8Za_grey-divider1",
  "grey_divider1": "F5r8Za_grey_divider1",
  "hidden": "F5r8Za_hidden",
  "iframe": "F5r8Za_iframe",
  "image_content": "F5r8Za_image_content",
  "image_title": "F5r8Za_image_title",
  "images_comment_section": "F5r8Za_images_comment_section",
  "images_left": "F5r8Za_images_left",
  "images_para": "F5r8Za_images_para",
  "info_bar2": "F5r8Za_info_bar2",
  "input_group": "F5r8Za_input_group",
  "input_group1": "F5r8Za_input_group1",
  "label": "F5r8Za_label",
  "like_btn": "F5r8Za_like_btn",
  "like_faq": "F5r8Za_like_faq",
  "liked": "F5r8Za_liked",
  "link_topic": "F5r8Za_link_topic",
  "mobile_view1": "F5r8Za_mobile_view1",
  "name_detail": "F5r8Za_name_detail",
  "new_comment": "F5r8Za_new_comment",
  "reaction_bar": "F5r8Za_reaction_bar",
  "share_link": "F5r8Za_share_link",
  "submit_btn": "F5r8Za_submit_btn",
  "title_head2": "F5r8Za_title_head2",
  "updated_detail": "F5r8Za_updated_detail",
  "user_comment": "F5r8Za_user_comment",
  "user_name": "F5r8Za_user_name",
  "wrapper_detail": "F5r8Za_wrapper_detail",
});
